// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

// Teller Online Files
import {
    AuthorizationConsentModule
} from 'apps/public-portal/src/app/shared/components/authorization-consent/authorization-consent.component';
import { PaymentConsentDialogComponent } from './payment-consent-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        AuthorizationConsentModule
    ],
    declarations: [PaymentConsentDialogComponent],
    exports: [PaymentConsentDialogComponent]
})
export class PaymentConsentDialogModule {}
